<template>
    <header class="encabezado" :class="{ 'header-20': isSpecialPage }">
      <router-link to="/" class="logotipo"><img src="/images/header/grupostudiologo.png" alt="Grupo Estudio logo"></router-link>

      <!-- hamburger (mobile) -->
      <button 
        class="btn-hamburger" 
        :class="{ open: mobileOpen }" 
        @click="toggleMobile" 
        :aria-expanded="mobileOpen" 
        aria-label="Abrir menú"
      >
        <i :class="mobileOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'"></i>
      </button>

      <nav class="navegacion-principal" :class="{ open: mobileOpen }">
        <ul>
          <!-- Formación (con submenús) -->
          <li class="desplegable" :class="{ 'open-mobile': isOpen('formacion') }">
            <button
              class="btn-desplegar"
              aria-haspopup="true"
              @click.prevent="toggleSubmenu('formacion')"
              :aria-expanded="isOpen('formacion')"
            >
              Formación
              <i class="fa-solid fa-chevron-down icono-chevron" aria-hidden="true"></i>
            </button>

            <ul class="contenido-desplegable" aria-label="submenu formación">
              <!-- Formación profesional -->
              <li class="item-desplegable tiene-derecha" :class="{ 'open-mobile': isOpen('formacion-profesional') }">
                <button
                  class="subbtn"
                  @click.prevent="toggleSubmenu('formacion-profesional')"
                  :aria-expanded="isOpen('formacion-profesional')"
                >
                  <i class="fa-solid fa-briefcase icono-team"></i>
                  Formación profesional
                  <i class="fa-solid fa-chevron-down icono-chevron" aria-hidden="true"></i>
                </button>

                <ul class="submenu-derecha" aria-label="profesional">
                  <li>
                    <router-link to="/formacion-profesional/administracion-finanzas">
                      <i class="fa-solid fa-coins icono-pequeno" aria-hidden="true"></i>
                      Administración y finanzas
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/formacion-profesional/daw">
                      <i class="fa-solid fa-laptop-code icono-pequeno" aria-hidden="true"></i>
                      Desarrollo de aplicaciones web
                    </router-link>
                  </li>
                </ul>
              </li>

              <!-- Formación gratuita -->
              <li class="item-desplegable tiene-derecha" :class="{ 'open-mobile': isOpen('formacion-gratuita') }">
                <button
                  class="subbtn"
                  @click.prevent="toggleSubmenu('formacion-gratuita')"
                  :aria-expanded="isOpen('formacion-gratuita')"
                >
                  <i class="fa-solid fa-gift icono-team"></i>
                  Formación gratuita
                  <i class="fa-solid fa-chevron-down icono-chevron" aria-hidden="true"></i>
                </button>

                <ul class="submenu-derecha" aria-label="gratuita">
                  <li>
                    <router-link to="/formacion-gratuita/desempleados">
                      <i class="fa-solid fa-search icono-pequeno" aria-hidden="true"></i>
                      Desempleados
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/formacion-gratuita/autonomos">
                      <i class="fa-solid fa-laptop icono-pequeno" aria-hidden="true"></i>
                      Autónomos/Ocupados
                    </router-link>
                  </li>
                </ul>
              </li>

              <!-- Otros elementos -->
              <li class="item-desplegable">
                <router-link to="/universidad">
                  <i class="fa-solid fa-graduation-cap icono-team"></i>
                  Universidad
                </router-link>
              </li>
              <li class="item-desplegable">
                <router-link to="/endnote">
                  <i class="fa-solid fa-book icono-team"></i>
                  Curso EndNote
                </router-link>
              </li>
            </ul>
          </li>


          <!-- Otras opciones principales -->
          
          <li class="desplegable" :class="{ 'open-mobile': isOpen('formacion-empresas') }">
            <button class="btn-desplegar" aria-haspopup="true" @click.prevent="toggleSubmenu('formacion-empresas')" :aria-expanded="isOpen('formacion-empresas')">Formación empresas <i class="fa-solid fa-chevron-down icono-chevron" aria-hidden="true"></i></button>
            <ul class="contenido-desplegable" aria-label="submenu formacion empresas">
              <li class="item-desplegable">
                <router-link to="/formacion-empresas/formacion-bonificada"><i class="fa-solid fa-book-open icono-team"></i>Formación bonificada</router-link>
              </li>
              <li class="item-desplegable">
                <router-link to="/formacion-empresas/practicas-empresas"><i class="fa-solid fa-user-tie icono-team"></i>Prácticas empresas</router-link>
              </li>
              <li class="item-desplegable">
                <router-link to="/formacion-empresas/team-building"><i class="fa-solid fa-users-gear icono-team"></i>Team building</router-link>
              </li>
            </ul>
          </li>

          <li class="desplegable" :class="{ 'open-mobile': isOpen('ingles') }">
            <button class="btn-desplegar" aria-haspopup="true" @click.prevent="toggleSubmenu('ingles')" :aria-expanded="isOpen('ingles')">Inglés <i class="fa-solid fa-chevron-down icono-chevron" aria-hidden="true"></i></button>
            <ul class="contenido-desplegable" aria-label="submenu ingles">
              <li class="item-desplegable">
                <router-link to="/ingles/certificaciones"><i class="fa-solid fa-medal icono-team"></i>Certificaciones</router-link>
              </li>
              <li class="item-desplegable">
                <router-link to="/ingles/20go"><i class="fa-regular fa-comment-dots icono-team"></i>20&GO</router-link>
              </li>
            </ul>
          </li>

          <li><router-link to="/oposiciones">Oposiciones</router-link></li>
          <li><router-link to="/valingual">Inmersión cultural</router-link></li>
          <li><router-link to="/aulas">Alquiler de aulas</router-link></li>
          <a href="https://campus.grupostudio.es" class="btn-aula">Aula virtual</a>
        </ul>
      </nav>
    </header>
</template>

<script>

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { watch } from 'vue';

export default {
    name: 'SiteHeader',
    props: {
      mobileOpen: {
        type: Boolean,
        default: false
      },
      openSubmenus: {
        type: Object,
        default: () => ({})
      }
    },
    emits: ['toggleMobile', 'toggleSubmenu'],
    setup(props, { emit }) {
      const route = useRoute();

      const isSpecialPage = computed(() => route.name === '20Go' || route.name === 'Landing');

      watch(
        () => route.fullPath,
        () => {

          if (props.mobileOpen) {
            emit('toggleMobile');
          }
        }
      );
      return {
        isSpecialPage
      };
    },
    
    
    methods: {
      toggleMobile() {
        this.$emit('toggleMobile')
      },
      toggleSubmenu(key) {
        this.$emit('toggleSubmenu', key)
      },
      isOpen(key) {
        return !!(this.openSubmenus && this.openSubmenus[key])
      }
    }
}
</script>

<style lang="scss" scoped>

* { 
  margin:0; 
  padding:0; 
  box-sizing: border-box;
}


.btn-hamburger { 
  display: none; 
  background: transparent; 
  border: none;
  font-size: 28px; 
  color: #e20000;
  cursor: pointer;
  padding: 5px;
  transition: transform 0.3s ease;

  &:hover {
    color: #e20000;
  }
}
:root { 
  --font-sans: 'Montserrat', 'Nunito Sans', system-ui;
}

body { 
  font-family: var(--font-sans); color:#222;
}


.encabezado {
  display:flex;
  flex-direction: row;
  justify-content:center;
  align-items:center;
  gap: 10px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 25px;
  padding-top: 42px;
  z-index: 2000;
  img { 
    width:180px; 
    height:60px; 
    object-fit:contain;
    margin-right: 50px;
  }
}


.navegacion-principal{ 

  a { 
    text-decoration:none; 
    text-align:center; 
    display:inline-block;
  }
}

.navegacion-principal > ul {
  display: flex;
  align-items: center;
  gap: 40px;      
  list-style: none;
  
}


.navegacion-principal > ul > li > a,
.navegacion-principal > ul > li > button {
  text-decoration: none;
  color: #000000;
  font-weight: 600;
  font-size: 17px;
  text-align: center;
  display: inline-block;
  position: relative; 
  padding-bottom: 6px;
}

.header-20 {
  // Cuando estemos en 20&Go, buscamos los links y botones
  .navegacion-principal > ul > li > a,
  .navegacion-principal > ul > li > button {
    text-shadow: 0 0px 10px rgba(0, 0, 0, 0.5); 
    color: #ffffff;
  

    .icono-chevron {
      color: #ffffff !important; 
    }
  }

}


.navegacion-principal > ul > li > a::after,
.navegacion-principal > ul > li > button::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 3px;
  background: linear-gradient(90deg, #e20000 0%, #ff6b6b 100%);
  transform-origin: left center;
  transform: scaleX(0);
  transition: transform 220ms cubic-bezier(.22,.9,.39,1);
  border-radius: 2px;
}

.navegacion-principal > ul > li:hover > a::after,
.navegacion-principal > ul > li:hover > button::after {
  transform: scaleX(1);
}

.btn-aula {
  background-color: #e20000; 
  color: #fff; 
  border:none; 
  text-decoration:none;
  padding:10px 20px; 
  border-radius:25px; 
  font-weight:600; 
  font-size:16px;
  font-family: var(--font-sans);
  transition: background-color 0.3s, color 0.3s;
  cursor:pointer; 

  &:hover { 
    background-color: #ffe9e9; 
    color: #ff0000;
    border: 1px solid #ff0000;
  }
}

.desplegable { 
  position:relative;

  i{
    margin-left: 6px;
    color: #555;
    font-size: 0.8rem;
  }
}

.btn-desplegar { 
  background:none; 
  border:none; 
  cursor:pointer; 
  font:inherit;
}


.contenido-desplegable {
  position: absolute;
  top: 100%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: start;
  transform: translateX(-50%) translateY(-6px);
  width: 330px;                
  padding: 8px 6px;
  border-radius: 12px;
  box-shadow: 0 0 30px rgba(18, 24, 33, 0.147);
  background: rgb(255, 255, 255);
  opacity: 0;
  pointer-events: none;
  transition: opacity 220ms cubic-bezier(.22,.9,.39,1), transform 220ms cubic-bezier(.22,.9,.39,1);
  transition-delay: 0.18s;


  ul, li { list-style: none; margin: 0; padding: 0; }

  > li { padding: 8px 6px; }
  

  .item-desplegable { position: relative;
    width: 100%;
    
  }

  .icono-team {
    margin-right: 13px;
    color: rgb(190, 0, 0); 
    background-color: rgb(255, 243, 243); 
    border: 1px solid rgba(203, 0, 0, 0.2);
    font-size: large;
    width: 35px;
    height: 35px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  //icono pequeño para items de submenu
  .icono-pequeno {
    margin-right: 8px;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-size: 0.95rem;
    color: #0f1720;
    background: transparent;
  }

  .subbtn { background: none; border: none; padding: 6px 8px; width: 100%; cursor: pointer; font-weight: 500; color: #0f1720; font-size:14px; display:flex; align-items:center; position:relative; font-family: var(--font-sans); white-space: normal; }

  /* apply Montserrat specifically to the titles with submenus */
  .item-desplegable.tiene-derecha .subbtn {
    font-family: 'Montserrat', var(--font-sans);
  }


  .icono-chevron {
    font-size: 0.9rem;
    color: rgba(15,23,32,0.6);
    transition: transform 180ms ease;
    margin-left: 8px;
  }


  /* rotate chevrons when their parent dropdown is open (mobile) or on hover (desktop) */
  .item-desplegable.tiene-derecha.open-mobile .icono-chevron,
  .item-desplegable.open-mobile .icono-chevron,
  .desplegable.open-mobile .icono-chevron,
  .desplegable:hover .icono-chevron {
    transform: rotate(180deg);
  }

  .contenido-desplegable { text-align: left }
  a {padding: 8px 8px; text-decoration: none; width: 100%; text-align: left; color: #0f1720; border-radius: 25px; font-size:14px; font-weight:500; }
  a:hover { color: #d00000; font-weight: 700; }

 
  .contenido-desplegable > li + li { border-top: 1px solid rgba(2,6,23,0.04); margin-top: 6px; padding-top: 8px }


  .submenu-derecha {
    width: 100%;
    position: static;
    display: flex;
    flex-direction: column;
    align-items: start;
    margin-left: 0px;
    max-height: 0; 
    overflow: hidden;
    margin-top: 6px;
    padding: 0 6px; 
    background: transparent;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-6px);
    transition: max-height 220ms ease, opacity 200ms cubic-bezier(.22,.9,.39,1), transform 200ms cubic-bezier(.22,.9,.39,1);
  }

  .item-desplegable.open-mobile > .submenu-derecha {
    max-height: 400px;
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }

  

  .submenu-derecha li { padding: 6px 0; }
  .submenu-derecha li a {
    color: #000;
    font-weight:500;
    font-size:14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding-left: 6px;
    &:hover { 
      color: #d00000; 
      font-weight: 700; 
    }
  }

  
}


.desplegable:hover > .contenido-desplegable {
  opacity:1; 
  pointer-events:auto; 
  transform:translateX(-50%) translateY(0); 
  transition-delay:0s;
}



  @media (max-width: 768px) {

    .encabezado {
      padding: 15px 5px 0 15px;
      flex-direction: row-reverse;
      justify-content: space-between;
      gap: 6px;
      width: 66%;
      img { width: 120px; height: auto; margin: 8px 0; }
    }

    .header-20 {
  // Cuando estemos en 20&Go, buscamos los links y botones
  .navegacion-principal > ul > li > a,
  .navegacion-principal > ul > li > button {
    text-shadow: none; 
    color: #000000;
  

    .icono-chevron {
      color: #363636 !important; 
    }
  }

}

  .btn-hamburger { display: inline-flex; align-items:center; justify-content:center; background:transparent; border:none; width:44px; height:44px; cursor:pointer; margin-left: 0; align-self: center; }

  .btn-hamburger .hamburger { display:block; width:22px; height:2px; background:#222; position:relative; border-radius:2px; transition: background 220ms ease; }

  .btn-hamburger .hamburger::before, .btn-hamburger .hamburger::after { content:''; position:absolute; left:0; width:22px; height:2px; background:#222; border-radius:2px; transition: transform 220ms cubic-bezier(.22,.9,.39,1), opacity 180ms ease; transform-origin: center; }
  .btn-hamburger .hamburger::before { transform: translateY(-7px); }
  .btn-hamburger .hamburger::after { transform: translateY(7px); }
  /* open state: hide middle bar and rotate pseudo elements into an X centered on the bar */
  .btn-hamburger.open .hamburger { background: transparent; }
  .btn-hamburger.open .hamburger::before { transform: translateY(0) rotate(45deg); }
  .btn-hamburger.open .hamburger::after { transform: translateY(0) rotate(-45deg); }


    .navegacion-principal{
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      transform: translateY(-6px);
      opacity: 0;
      pointer-events: none;
      transition: transform 220ms ease, opacity 220ms ease;
      background: #fff;
      border-radius: 12px;
      width: 300px;
      height: auto;
      box-shadow: 0 8px 20px rgba(18,24,33,0.06);
      border-top: 1px solid rgba(2,6,23,0.04);
      z-index: 1200;
    }

  .logotipo { order: 1; }
  .btn-hamburger { order: 2; }
  .btn-aula { order: 3; align-self: flex-start; margin: 8px 0; }
  .navegacion-principal { order: 4; }

    .navegacion-principal.open{
      transform: translateY(0);
      opacity: 1;
      pointer-events: auto;
    }

    .navegacion-principal > ul { flex-direction: column; gap: 0; padding: 12px 16px; }
    .navegacion-principal > ul > li { width: 100%; }
    .navegacion-principal > ul > li > a,
    .navegacion-principal > ul > li > button { display:block; width:100%; padding: 12px 8px; text-align:left; font-size:16px; border-radius:6px; }



    .contenido-desplegable {
      display: none;
      position: static !important;
      transform: none !important;
      opacity: 1 !important;
      pointer-events: auto !important;
      width: 100% !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      background: transparent !important;
      padding: 0 !important;
    }

    .desplegable.open-mobile > .contenido-desplegable {
      display: block !important;
      padding: 8px 0 !important;
    }

    .contenido-desplegable > li + li { border-top: none; margin-top: 0; padding-top: 0; }
    .submenu-derecha { display: none; max-height: 0; opacity:0; transform: translateY(-6px); pointer-events: none; padding-left: 12px; transition: max-height 220ms ease, opacity 200ms ease, transform 200ms ease; }
    .item-desplegable.open-mobile > .submenu-derecha { display:flex; max-height: 400px; opacity:1; transform: translateY(0); pointer-events:auto; }


  }






</style>
